import qs from 'qs';

export const createUrl = state => {
  return `?${qs.stringify(state)}`;
};

export const searchStateToUrl = (pathname, searchState) =>
  searchState ? `${pathname}${createUrl(searchState)}` : '';

export const urlToSearchState = ({ search }) => {
  return search ? qs.parse(search.slice(1)) : {};
};
